document.addEventListener("DOMContentLoaded", () => {
  function categories() {
    const sumCategoryElement = document.querySelector(
      '.accordion__body.facets__accordion-body[data-param-name="filter.p.product_type"]'
    );

    const categories = {
      benches: [],
      rugs: [],
      pillows: [],
    };

    const targetInputs = sumCategoryElement.querySelectorAll(
      "li[data-value] input"
    );

    targetInputs.forEach((input) => {
      const value = input.value.toLowerCase();
      const parentLi = input.closest("li[data-value]");

      if (value === "benches") {
        categories.benches.push(parentLi);
      } else if (value && value.includes("pillow")) {
        categories.pillows.push(parentLi);
      } else if (value && value.includes("rug")) {
        categories.rugs.push(parentLi);
      }
    });

    return categories;
  }

  function sizes() {
    const sumSizeElement = document.querySelector(
      '.accordion__body.facets__accordion-body[data-param-name="filter.p.m.custom.size"]'
    );

    const sizes = {
      rugs: [],
      pillows: [],
      benches: [],
    };

    const targetSizeInputs = sumSizeElement.querySelectorAll(
      "li[data-value] input[data-option-value]"
    );

    targetSizeInputs.forEach((input) => {
      let dataOptionValue = input
        .getAttribute("data-option-value")
        .toLowerCase();

      dataOptionValue = dataOptionValue.replace(/['"\\]/g, "").trim();

      const parentLi = input.closest("li[data-value]");

      if (
        ["small", "large", "medium", "oversize", "runners"].includes(
          dataOptionValue
        )
      ) {
        sizes.rugs.push(parentLi);
      } else if (["12-x-20", "16-x-24", "16-x-16","20-x-20"].includes(dataOptionValue)) {
        sizes.pillows.push(parentLi);
      } else if (["35-x-18-x-18", "30-x-30-x-18", "48-x-18-x-18","35-x-35-x-18"].includes(dataOptionValue)) {
        sizes.benches.push(parentLi);
      }
    });

    return sizes;
  }

  function updateSizesVisibility() {
    const sizesData = sizes();
    const categoriesData = categories();

    // check all selected inputs
    const selectedCategories = [];

    Object.keys(categoriesData).forEach((category) => {
      categoriesData[category].forEach((li) => {
        const input = li.querySelector("input");
        if (input.checked) {
          selectedCategories.push(category);
        }
      });
    });

    // Rug-specific logic
    const colorPatternElement = document.querySelector(
      '[data-param-name="filter.v.t.shopify.color-pattern"]'
    );
    let parentColor = colorPatternElement.closest(".accordion__section")

    if (!selectedCategories.includes("rugs")) {
      if (parentColor) {
        parentColor.style.display = "none";
      }
    } else {
      if (parentColor) {
        parentColor.style.display = "block";
      }
    }
    if (selectedCategories.length == 0) {
        parentColor.style.display = "block";
    }

    // if no one is selected then show all
    if (selectedCategories.length === 0) {
      Object.keys(sizesData).forEach((category) => {
        sizesData[category].forEach((li) => {
          li.style.display = "block";
        });
      });
      return;
    }

    // none all
    Object.keys(sizesData).forEach((category) => {
      sizesData[category].forEach((li) => {
        li.style.display = "none";
      });
    });

    // only selected li visible
    selectedCategories.forEach((category) => {
      if (sizesData[category]) {
        sizesData[category].forEach((li) => {
          li.style.display = "block";
        });
      }
    });
  }

  function initCategories() {
    const categoriesData = categories();

    // event listener for li elements
    Object.keys(categoriesData).forEach((category) => {
      categoriesData[category].forEach((li) => {
        const input = li.querySelector("input");

        li.addEventListener("click", () => {
          updateSizesVisibility();
        });
      });
    });
  }

  initCategories();
  updateSizesVisibility();
});
